import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment-timezone';

@Pipe({
    name: 'tzDate',
    pure: true
})
export class TZDatePipe extends DatePipe implements PipeTransform {
	constructor() {
		const locale = inject(LOCALE_ID);

		super(locale);
	}

	transform(value: string | Date | null, format?: string, timezone?: string, locale?: string): any {
		return super.transform(value, format, undefined, locale) + ' ' + moment(value).tz(timezone).format('z');
	}
}
